export const Account = {
  ShowMeTheRopesBtn: 'show-me-the-ropes-btn',
  LogMeInBtn: 'log-me-in-btn',
} as const;
